import { genDefaultPitchDataMap } from '@web-common/state/reducer/salesPitchReducer/config';
import { salesPitchRequest as request } from '@web-common/state/reducer/salesPitchReducer/request';
export const salesPitchReducers = {
    doUpdateAny: (state, action) => {
        const { name, data } = action.payload || {};
        if (name && state && state[name] !== undefined) {
            try {
                state[name] = data;
            }
            catch (e) {
                console.warn('[doUpdateAny Error]', name, e);
            }
        }
        else {
            console.warn('[doUpdateAny Error]', name);
        }
    },
    doUpdateDataMapByStage(state, action) {
        const { stageId, newList } = action.payload;
        state.dataMap = Object.assign(Object.assign({}, state.dataMap), { [stageId]: newList });
    },
    doResetPage(state) {
        state.isLoading = false;
        state.isFetchFailed = false;
        state.selectedStageId = '';
        state.config = request.getLocalSalesPitchConfig();
        state.searchDataMap = genDefaultPitchDataMap();
        state.searchInput = '';
        state.dataMap = genDefaultPitchDataMap();
    },
    doCloseDrawer(state) {
        state.drawerType = '';
        state.drawerVisible = false;
        state.drawerDataId = '';
    },
};
